// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-form__footer{display:flex;justify-content:center;border-top:solid 1px var(--background--spacer);padding:24px 0;padding-bottom:80px;margin:0 16px}.c-form__footer-button{min-width:70px;min-height:40px;border:none}@media(min-width: 768px){.c-form__footer-button{min-height:auto}}.c-form__footer-button:first-child{margin-right:8px}.c-form__footer-button-wide{width:100%}", ""]);
// Exports
module.exports = exports;
